import { Switch } from "@mui/material";
import PiWidgetToggleButton from "../../../components/pi_widget/PiWidgetToggleButton";
import PiSwitch from "../../../components/PiSwitch";

export default function NodeToggle(props: {
  label: string;
  value: boolean;
  onChange: (value: boolean) => void;
}) {
  const toggle = (
    <PiSwitch checked={props.value} label={""} onChange={props.onChange} />
  );

  const label = (
    <div className="text-creator-text text-[14px] font-medium flex-1 truncate">
      {props.label}
    </div>
  );

  const sw = (
    <Switch
      checked={props.value}
      onChange={(event, checked) => props.onChange(checked)}
    />
  );

  return (
    <div className="flex flex-row items-center w-full h-full">
      {label}
      <div className="flex justify-items-start items-start">{sw}</div>
    </div>
  );
}
